import { render, staticRenderFns } from "./taoliifycont.vue?vue&type=template&id=4e9b5507&scoped=true&"
import script from "./taoliifycont.vue?vue&type=script&lang=js&"
export * from "./taoliifycont.vue?vue&type=script&lang=js&"
import style0 from "./taoliifycont.vue?vue&type=style&index=0&id=4e9b5507&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9b5507",
  null
  
)

export default component.exports